import React, {
  Fragment,
  useEffect,
  useRef,
  useMemo,
  useState,
  useCallback,
} from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";

import Slide from "@mui/material/Slide";
import {
  Box,
  FormControlLabel,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Select,
  Switch,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
} from "@mui/material";

import { IoMdClose } from "react-icons/io";

import PropTypes from "prop-types";

import parse from "html-react-parser";
import axios from "axios";
import axiosInstance from "../CommonGlobals/axiosInstance.js";
import { orderBy, set } from "lodash";
import {
  MdArrowBack,
  MdArrowForward,
  MdClose,
  MdFemale,
  MdMale,
  MdInfoOutline,
} from "react-icons/md";

import { BiMale } from "react-icons/bi";
import { FaFemale } from "react-icons/fa";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import { useSwipeable } from "react-swipeable";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { usePath } from "../CommonGlobals/PathContext";
import { GiSteeringWheel } from "react-icons/gi";
import { MdOutlineScreenRotationAlt } from "react-icons/md";
import { TbH3 } from "react-icons/tb";

import SeatLayoutVerticalSkeleton from "../CommonGlobals/SeatLayoutVerticalSkeleton";

import { CiLocationArrow1, CiLocationOn, CiPhone } from "react-icons/ci";
import { TbView360, TbView360Number } from "react-icons/tb";
import { HiClipboardCopy } from "react-icons/hi";
import { FaRegCopy } from "react-icons/fa6";

import { useAppGlobalState } from "../CommonGlobals/Store";

import { TransitionGroup } from "react-transition-group";

import { Transition } from "react-transition-group";
import ComponentLevelLoader from "../CommonGlobals/ComponentLevelLoader.jsx";

import PlatformDetector from "../CommonGlobals/PlatformDetector";
import { MISBookingMode } from "../CommonGlobals/TRMISBookingMode";
import { getPgSelectorUrlString } from "../CommonGlobals/PGSelector.js";
import { sendEventTobackend } from "../CommonGlobals/sendEventDataTobackend";
import ContactPhone from "./ContactPhone.jsx";

const customTheme = createTheme({
  palette: {
    theme: {
      primary: "#1F1F1F", // Blue color
      secondary: "#3D18B5", // Blue color
      button: "#F4CC08", // Blue color
    },
  },
});

const TransitionDialog = React.forwardRef(
  function TransitionDialog(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  },
);

const duration = 100;

const defaultStyle = {
  // Define which properties to transition: transform and opacity
  transition: `transform ${duration}ms ease-in-out, opacity ${duration}ms ease-in-out`,

  // Set the initial visual state
  transform: "scaleX(0)",
  transformOrigin: "left center", // Ensure it scales from the left
  opacity: 0,

  // Important: This element will still take up space in the layout,
  // you might want to wrap content to manage height/layout naturally.
};

// Define the styles for each phase of the transition
const transitionStyles = {
  // We don't change the transform here, as 'entered' handles the end state
  entering: { opacity: 0.5, transform: "scaleX(0.1)" },

  // The final, visible state
  entered: { opacity: 1, transform: "scaleX(1)" },

  // States when hiding
  exiting: { opacity: 0.5, transform: "scaleX(0.1)" },
  exited: { opacity: 0, transform: "scaleX(0)" },
};

// const Transition_for_slides = React.forwardRef(function Transition(props, ref) {
//   // Ensure mountOnEnter and unmountOnExit are set for proper sliding behavior
//   return <Slide direction="up" ref={ref} mountOnEnter unmountOnExit {...props} />;
// });

function CustomTabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      hidden={value !== index}
      {...other}
      style={{ padding: 0 }}
    >
      <Box sx={{ p: 1, display: value === index ? "block" : "none" }}>
        {children}
      </Box>
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function CustomBDTabPanel(props) {
  const { children, value, index, ...other } = props;
  const nodeRef = useRef(null);
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`bd-tabpanel-${index}`}
      aria-labelledby={`bd-tab-${index}`}
      {...other}
    >
      <Transition nodeRef={nodeRef} in={value == index} timeout={duration}>
        {(state) => (
          <div
            ref={nodeRef}
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
          >
            {children}
          </div>
        )}
      </Transition>
    </div>
  );
}

CustomBDTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const JourneyDailogSmallScreen = ({
  dailogInputData = {
    journeyDataUrl: "/seatArrangementdirectdata.json",
  },
  open = false,
  currentTab = 0,
  dialogClose,
  paymentUrl = "/payments",
}) => {
  const [globalData, setGlobalData] = useAppGlobalState();
  // const [dailogOpen, setDailogOpen] = useState(open);
  const [tabValue, setTabValue] = useState(currentTab);
  const [tabBDValue, setTabBDValue] = useState(0);
  // const fromDateRef = useRef();
  const [layoutdata, setLayoutData] = useState(null);

  const [parsedData, setParsedData] = useState(null);

  const [isLayoutDataLoading, setIsLayoutDataLoading] = useState(false);

  const [pickupPoints, setPickupPoints] = useState(null);
  const [droppingPoints, setDroppingPoints] = useState(null);

  const [selectedBoarding, setSelectedBoarding] = useState(null);
  const [selectedDropping, setSelectedDropping] = useState(null);

  const [selectedBoardingName, setSelectedBoardingName] = useState(null);
  const [selectedDroppingName, setSelectedDroppingName] = useState(null);

  const [selectedSeats, setSelectedSeats] = useState([]);

  const [subtotal, setSubTotal] = useState(0);
  const [gstInpercent, setGstInpercent] = useState(null);
  const [discountInPercent, setDiscountInPercent] = useState(0);
  const [totalGst, setTotalGst] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [grandwithoutDisc, setGrandwithoutDisc] = useState(0);

  const [selectedGender, setSelectedGender] = useState("Male");
  const [updatedSeats, setUpdatedSeats] = useState([]);

  const { paths } = usePath();

  const [currentJourneyId, setCurrentJourneyId] = useState(null);
  const [currentJourneyType, setCurrentJourneyType] = useState("ONWARD");
  const [currentCoachId, setCurrentCoachId] = useState(null);

  const [currentFromCityId, setCurrentFromCityId] = useState(null);
  const [currentToCityId, setCurrentToCityId] = useState(null);

  const [layoutOrientation, setLayoutOrientation] = useState(2);
  const [layoutDisplayCssClass, setLayoutDisplayCssClass] = useState(1);
  const [layoutsArrayData, setLayoutsArrayData] = useState(null);

  const [layoutsList, setLayoutsList] = useState(null);

  const [layoutObject, setLayoutObject] = useState(null);

  const [seatsBookedList, setSeatBookedList] = useState(null);
  const [allSeatDeatils, setAllSeatDeatils] = useState(null);
  const [frompayload, setFormPayload] = useState(null);
  const formref = useRef();

  const [onwardDateFormatWithMonthName, setOnwardDateFormatWithMonthName] =
    useState();
  const [onwardDayName, setOnwardDayname] = useState();
  const [isSeatFlipped, setIsSeatFlipped] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [deviceType, setDeviceType] = useState(0);

  const [MISBookingModeSate, setMISBookingModeState] = useState(0);

  const [pgselectorUrl, setPgselectorUrl] = useState("");
  const [isTermsAndConditionsChecked, setIsTermsAndConditionsChecked] =
    useState();

  const [isInfoExpanded, setIsInfoExpanded] = useState(false);

    const passengerSectionRef = useRef(null);

     const dialogContentRef = useRef(null);

  // set up global values

  // console.log(globalData);

  useEffect(() => {
    console.log(globalData);

    setContactDetails({
      mobile: globalData?.SignedPassenger?.IsPassengerSignedIn
        ? globalData?.SignedPassenger?.SignedPassenger?.MobileNumber
        : "",
      email: "",
    });
  }, [globalData]);

  useEffect(() => {
    if(dialogContentRef.current){
      dialogContentRef.current.scrollTop = 0;
    }
  },[tabValue]);

  useMemo(() => {
    const onwarddate = globalData.onwardDate;
    let result_with_slash = onwarddate.replace(/-/g, "/");
    let result = result_with_slash.replace(/\/\s*-/g, "-");
    const parts = result.split(/\D+/);

    //  console.log(parts);
    var day = parseInt(parts[0]);
    var month = parseInt(parts[1]);
    var year = parseInt(parts[2]);

    var dateObject = new Date(year, month - 1, day);
    // console.log(dateObject);
    const options = { month: "short" };
    const monthName = new Intl.DateTimeFormat("en-US", options).format(
      dateObject,
    );

    const dayOptions = { weekday: "long" }; // "short" → Mon, Tue; "narrow" → M, T
    const dayName = new Intl.DateTimeFormat("en-US", dayOptions).format(
      dateObject,
    );
    // console.log("Day:", dayName);
    setOnwardDateFormatWithMonthName(`${day}-${monthName}-${year}`);
    setOnwardDayname(dayName);
  }, []);

  // end of global values

  useEffect(() => {
    const TrviaAndMisData = MISBookingMode();
    setDeviceType(TrviaAndMisData.deviceType);
    setMISBookingModeState(TrviaAndMisData.MISBookingMode);

    // if (PlatformDetector.isDesktop()) {
    //         setDeviceType(21);
    //         setMISBookingMode(1); // desktop mode

    //       } else if (PlatformDetector.isMobile) {
    //         if (PlatformDetector.isAndroidWebView()) {
    //           setDeviceType(31); // android webview
    //           setMISBookingMode(2); // mobile android webview mode
    //         } else if (PlatformDetector.isIOSWebView()) {
    //           setDeviceType(41); // ios webview
    //            setMISBookingMode(2); // mobile ios webview mode
    //         } else {
    //           if (PlatformDetector.isAndroid()) {
    //             setDeviceType(22); // android browser
    //             setMISBookingMode(1); // mobile android webview mode
    //           } else if (PlatformDetector.isIOS()) {
    //             setDeviceType(22); // ios browser
    //             setMISBookingMode(1); // mobile ios webview mode
    //           } else {
    //             setDeviceType(23);
    //             setMISBookingMode(1); // mobile ios webview mode// other mobile browser
    //           }
    //         }
    //       } else if (PlatformDetector.isTablet()) {
    //         if (PlatformDetector.isAndroidWebView()) {
    //           setDeviceType(8); // android webview
    //           setMISBookingMode(2);
    //         } else if (PlatformDetector.isIOSWebView()) {
    //           setDeviceType(9); // ios webview
    //           setMISBookingMode(3);
    //         } else {
    //           if (PlatformDetector.isAndroid()) {
    //             setDeviceType(23);
    //             setMISBookingMode(1); // android browser
    //           } else if (PlatformDetector.isIOS()) {
    //             setDeviceType(23); // ios browser
    //             setMISBookingMode(1);
    //           } else {
    //             setDeviceType(22);
    //             setMISBookingMode(1); // other mobile browser
    //           }
    //         }
    //       } else {
    //         setDeviceType(23); // unknown
    //         setMISBookingMode(1);
    //       }
  }, []);

  useEffect(() => {
    console.log("detected device type is " + deviceType);
  }, [deviceType]);

  useEffect(() => {
    console.log("paths content");
    console.log(paths);
  }, [paths]);
  useEffect(() => {
    if (layoutOrientation == 1) {
      fetchLayoutData();
      setLayoutDisplayCssClass("layout-deck-content");
    } else {
      if (layoutOrientation == 2) {
        fetchLayoutData();
        setLayoutDisplayCssClass("layout-deck-content-vertical");
      }
    }
  }, [layoutOrientation]);

  // const [contactDetails, setContactDetails] = useState({
  //   mobile: globalData?.SignedPassenger?.IsPassengerSignedIn || window.__APP_STATE__?.IsPassengerSignedIn == 1
  //     ? globalData?.SignedPassenger?.SignedPassenger?.MobileNumber 
  //     : "",
  //   email: "",
  // });


  const [contactDetails, setContactDetails] = useState(() => {
  // 1. Check globalData first
  const gdPassenger = globalData?.SignedPassenger;
  const isGdSignedIn = gdPassenger?.IsPassengerSignedIn;
  
  if (isGdSignedIn) {
    return {
      mobile: gdPassenger?.SignedPassenger?.MobileNumber || "",
      email: "",
    };
  }

  // 2. Fallback to window.__APP_STATE__
  const appState = window.__APP_STATE__;
  const isAppSignedIn = appState?.IsPassengerSignedIn == 1;

  if (isAppSignedIn) {
    return {
      mobile: appState?.SignedPassenger?.MobileNumber || "",
      email: "",
    };
  }

  // 3. Default if no one is logged in anywhere
  return {
    mobile: "",
    email: "",
  };
});



  
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,
    formState: { errors, isValid },
  } = useForm({
    mode: "onChange", // live validation while typing
    defaultValues: {
      mobile: contactDetails.mobile || "",
      email: contactDetails.email || "",
      passengers: updatedSeats.map((s) => ({
        passangerName: s.passangerName || "",
        age: s.age || "",
      })),
      GSTNumber: "",
    },
  });

  const tabstyles = useMemo(
    () => ({
      color: "#1f1f1f",
      fontWeight: "500",
      fontSize: "13px",
      textTransform: "capitalize",
      padding: "0px 10px",
      margin: "0px 0px",
      height: "35px",
      minHeight: "35px",
      "&.Mui-selected": {
        backgroundColor: "#2D3FA8",
        color: "#fff",
      },
    }),
    [],
  );

  const tabBDstyles = useMemo(
    () => ({
      color: "#2D3FA8",
      fontWeight: "500",
      fontSize: "13px",
      textTransform: "capitalize",
      padding: "0px 10px",
      margin: "0px 0px",
      height: "35px",
      minHeight: "35px",
      "&.Mui-selected": {
        backgroundColor: "#F4CC08",
        color: "#2D3FA8",
        borderRadius: "5px",
      },
    }),
    [],
  );

  // const tabsStyle = { height: "35px", minHeight: "35px" };

  // const handleClose = () => {
  //   setDailogOpen(false);
  // };


  const handleClose = () => {
    dialogClose({ lastDailogOpenValue: false });
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // useEffect(() => {
  //   setDailogOpen(open);
  // }, [open]);

  // useEffect(() => {
  //   dialogClose({ lastDailogOpenValue: dailogOpen });
  // }, [dailogOpen]);

  useEffect(() => {
    setTabValue(currentTab);
  }, [currentTab]);

  useEffect(() => {
    // console.log(dailogInputData);
    if (dailogInputData?.bus) {
      // console.log(dailogInputData?.bus);
      setPickupPoints(dailogInputData?.bus.Boardings);
      setDroppingPoints(dailogInputData?.bus.Droppings);
      setGstInpercent(dailogInputData?.bus.GSTPercent);
      setDiscountInPercent(parseFloat(dailogInputData?.bus.DiscountPercent));
      // fetchLayoutData();

      fetchLayoutDataAll();
      sendEventTobackend("ViewSeatsClicked", null, 1);
    }
  }, [dailogInputData]);

  const [ltd, setLtd] = useState(null);

  const fetchLayoutDataAll = useCallback(async () => {
    const templayoutobject = {};
    // console.log("preparing layout data...");
    // console.log(dailogInputData);
    setIsLayoutDataLoading(true);
    if (dailogInputData != null || dailogInputData != undefined) {
      if (dailogInputData.bus != null || dailogInputData.bus != undefined) {
        setCurrentJourneyId(dailogInputData.bus.JourneyID);
        setCurrentCoachId(dailogInputData.bus.CoachID);
        setCurrentFromCityId(dailogInputData.bus.BFCityID);
        setCurrentToCityId(dailogInputData.bus.BTCityID);
        const layouturlpoint =
          paths.layouturl +
          `?CoachID=${dailogInputData.bus.CoachID}&LayoutType=${layoutOrientation}`;
        // console.log(layouturlpoint);
        const layoutstatusurlpoint =
          paths.journeySeatsInfo +
          `?CoachID=${dailogInputData.bus.CoachID}&JourneyID=${dailogInputData.bus.JourneyID}&FromCityID=${dailogInputData.bus.BFCityID}&ToCityID=${dailogInputData.bus.BTCityID}`;
        // console.log(layoutstatusurlpoint);
        try {
          const res1 = await axios.get(`/${layoutstatusurlpoint}`);
          const firstResult = res1.data;
          // console.log("First Result")
          // console.log(firstResult);
          const parsed_first_result = JSON.parse(res1.data.ResponseData);
          // console.log('firstResult parsed');
          // console.log(parsed_first_result);
          if (parsed_first_result) {
            templayoutobject.seatBookedLists =
              parsed_first_result.seatBookedLists;
            templayoutobject.AllSeatDeatils =
              parsed_first_result.AllSeatDeatils;
          }

          const res2 = await axios.get(`/${layouturlpoint}`);
          const secondResult = res2.data;
          // console.log("second result");
          // console.log(secondResult);
          if (secondResult.Status) {
            const parsed_second_result = JSON.parse(res2.data.ResponseData);
            // console.log(parsed_second_result);
            templayoutobject.LayoutStr = parsed_second_result.LayoutStr;
            templayoutobject.SeatIDs = parsed_second_result.SeatIDs;
          } else {
            alert("Layout string data not available");
            return;
          }

          // console.log(templayoutobject);
          setLayoutObject(templayoutobject);
        } catch (err) {
          console.error("Error in chained calls:", err);
        }
      } else {
        alert("Dailog data has no bus data ");
      }
    } else {
      alert("Dailog data is not available...");
    }
  });

  const fetchLayoutData = useCallback(async () => {
    // console.log("fetching layout data...");
    //  console.log(dailogInputData);
    if (dailogInputData != null || dailogInputData != undefined) {
      if (dailogInputData.bus != null || dailogInputData.bus != undefined) {
        // console.log(dailogInputData.bus);
        setCurrentJourneyId(dailogInputData.bus.JourneyID);
        setCurrentCoachId(dailogInputData.bus.CoachID);

        const layouturlpoint =
          paths.layouturl +
          `?CoachID=${dailogInputData.bus.CoachID}&LayoutType=${layoutOrientation}`;
        // console.log(layouturlpoint);
        axios
          .get("/" + layouturlpoint)
          .then((response) => {
            // console.log(response.data);
            if (response.data) {
              if (response.data.StatusCode != 1) {
                alert("Layout data not found");
              } else {
                const ltdata = response.data.ResponseData;
                try {
                  const parsedData = JSON.parse(ltdata);
                  //setLayoutData(parsedData.LayoutStr);
                  // console.log(parsedData);
                  setLayoutsArrayData(parsedData.LayoutStr);
                } catch (e) {
                  alert("Error parsing layout data" + e.toString());
                  return;
                }

                // setLayoutData(response.data);
              }
            }
            //if (response.data) setLayoutData(response.data);
          })
          .catch((error) => {
            console.error("Error fetching layout data:", error);
          });
      }
    }
    // console.log(paths.layouturl);
    // const layouturlpoint = paths.layouturl + `?CoachID=${dailogInputData.bus.CoachID}&LayoutType=1`;
    // console.log(layouturlpoint);
    //  const res = await axios.get("/seatArrangementdirectdata.json");
    // console.log(res.data);
    // if (res.data) setLayoutData(res.data);
  });

  // useEffect(()=>{
  //   if(layoutsArrayData != null){
  //     console.log("layouts array data updated");
  //     if(Array.isArray(layoutsArrayData)){
  //       if(layoutsArrayData.length > 0){
  //          const seat_class = layoutOrientation === 1 ? "horizontal-layout-seats-seat" : "vertical-layout-seats-seat";
  //         const templayoutslist = layoutsArrayData.map((layoutItem) => {
  //              if(layoutItem.HTMLString != null && layoutItem.HTMLString != undefined){
  //                 console.log("layout item found");
  //                  var idpattern = `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-${layoutItem?.DeckName}-`
  //                  const rawString = layoutItem?.HTMLString.replace(
  //                   /##TDIDPREFIX##/g,
  //                    `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-${layoutItem?.DeckName}-`
  //                  );

  //                  console.log(rawString);

  //                   const options = {
  //                     replace: (node) => {
  //                       if (node.type == "tag" && node.name == "td") {
  //                         //console.log(node);
  //                         console.log(idpattern +'-tdSeatID_0');
  //                         return (
  //                           <td
  //                             rowSpan={node.attribs.rowspan}
  //                             colSpan={node.attribs.colspan}
  //                             style={{ minWidth: "40px" }}
  //                           >
  //                           { node.attribs.id === idpattern +'tdSeatID_0'?<div> {node.children.map((p) => p.data)} </div>:
  //                             <div
  //                               className={`${
  //                                 node.attribs.id === idpattern +'tdSeatID_0'
  //                                   ? "empty-seats"
  //                                   :
  //                                    layoutOrientation === 1 ?
  //                                    node.attribs.rowspan == "3"?'seat-vertical': seat_class:
  //                                    node.attribs.colspan == "3"?'seat-horizontal':seat_class

  //                               }  ${
  //                                 checkSeatSelected(node.attribs.id) ? "seat-checked" : ""
  //                               }`}
  //                               onClick={() => handleTdClick(node.attribs.id)}
  //                               id={node.attribs.id}
  //                             >
  //                               {node.children.map((p) => p.data)}
  //                               <div className="slot"></div>
  //                             </div>

  //                             }
  //                           </td>
  //                         );
  //                       }
  //                     },
  //                   };

  //                   const pdata = parse(rawString, options);

  //                   return {
  //                     OrientationType: layoutItem.OrientationType,
  //                     DeckName: layoutItem.DeckName,
  //                     DeckDisplayOrder: layoutItem.DeckDisplayOrder,
  //                     parsedData: pdata,
  //                   };

  //              }

  //       });

  //         setLayoutsList(templayoutslist);

  //       }else{
  //         alert("Layout data array is empty");
  //       }
  //     }else{
  //       alert("Layout data is not in expected array format");
  //     }
  //   }
  // },[layoutsArrayData]);

  useEffect(() => {
    // console.log("all seats details")
    // console.log(allSeatDeatils);

    // moving from seatArrayData

    if (layoutsArrayData != null) {
      // console.log("layouts array data updated");
      if (Array.isArray(layoutsArrayData)) {
        if (layoutsArrayData.length > 0) {
          if (seatsBookedList && allSeatDeatils && allSeatDeatils.length > 0) {
            // /////////////////////////////////////////////!SECTION

            
            const templayoutslist = layoutsArrayData.map((layoutItem) => {
              if (
                layoutItem.HTMLString != null &&
                layoutItem.HTMLString != undefined
              ) {
                // console.log("layout item found");
                var idpattern = `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-`;
                const rawString = layoutItem?.HTMLString.replace(
                  /##TDIDPREFIX##/g,
                  `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-`,
                );

                //  console.log(rawString);

                const options = {
                  replace: (node) => {

                    if (node.type == "tag" && node.name == "td") {
                      //console.log(node);

                      let html_id = node.attribs.id;

                      const numberd_id = html_id.replace(
                        `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-tdSeatID_`,
                        "",
                      );
                      const seatObject = [...allSeatDeatils];
                      let filteredSeat = seatObject.filter(
                        (item) => item.SeatID == numberd_id,
                      );
                      //alert("Seat Id is " + extract_id + "  the object is" + JSON.stringify(filteredSeat) );

                      let seat_to_pick =
                        filteredSeat?.length == 1 ? filteredSeat[0] : null;

                        // console.log("spancol spanrow");
                        // console.log(node.attribs.colspan);
                        // console.log(node.attribs.rowspan);

                      const seat_class =
                        layoutOrientation === 1
                          ? "horizontal-layout-seats-seat"
                          : node.attribs.rowspan == 1 ? 'seater-seat': "vertical-layout-seats-seat";  

                      // console.log(idpattern +'-tdSeatID_0');
                      return (
                        <td
                          rowSpan={node.attribs.rowspan}
                          colSpan={node.attribs.colspan}
                          style={{ minWidth: "40px" }}
                        >
                          {node.attribs.id === idpattern + "tdSeatID_0" ? (
                            <div> {node.children.map((p) => p.data)} </div>
                          ) : (
                            <div
                              className={`${
                                node.attribs.id === idpattern + "tdSeatID_0"
                                  ? "empty-seats"
                                  : layoutOrientation === 1
                                    ? node.attribs.rowspan == "3"
                                      ? "seat-vertical"
                                      : seat_class
                                    : node.attribs.colspan == "3"
                                      ? "seat-horizontal"
                                      : seat_class
                              } ${
                                checkIsSeatBooked(node.attribs.id) != null
                                  ? checkIsSeatBooked(node.attribs.id) == 1
                                    ? "booked-seat"
                                    : "women-seat"
                                  : checkSeatSelected(node.attribs.id)
                                    ? "seat-checked"
                                    : ""
                              }`}
                              onClick={() => {
                                if (checkIsSeatBooked(node.attribs.id)) {
                                  // console.log("No event attached");
                                } else {
                                  handleTdClick(node.attribs.id);
                                }
                              }}
                              id={node.attribs.id}
                            >
                              {checkIsSeatBooked(node.attribs.id) ? (
                                node.children.map((p) => p.data)
                              ) : (
                                <button
                                  class={`auto-seat-flip-button ${isSeatFlipped ? "flipped-seat" : ""}`}
                                >
                                  <span class="flip-seat-content text-seat-front">
                                    {" "}
                                    {node.children.map((p) => p.data)}{" "}
                                  </span>
                                  <span class="flip-seat-content text-seat-back">
                                    {" "}
                                    &#8377;{seat_to_pick.FARE}
                                  </span>
                                </button>
                              )}

                              <div className="slot"></div>
                            </div>
                          )}
                        </td>
                      );
                    }
                  },
                };

                const pdata = parse(rawString, options);

                return {
                  OrientationType: layoutItem.OrientationType,
                  DeckName: layoutItem.DeckName,
                  DeckDisplayOrder: layoutItem.DeckDisplayOrder,
                  parsedData: pdata,
                };
              }
            });

            setLayoutsList(templayoutslist);

            ///////////////////////////////////////////////
          } else {
            //alert("Seat Details array is empty");
          }
        } else {
          alert("Layout data array is empty");
        }
      } else {
        alert("Layout data is not in expected array format");
      }
    }

    // end of logic
  }, [
    allSeatDeatils,
    seatsBookedList,
    layoutsArrayData,
    selectedSeats,
    isSeatFlipped,
  ]);

  useEffect(() => {
    //  console.log("inuseeffect layoutobject");
    //  console.log(layoutObject);

    if (
      layoutObject &&
      layoutObject.seatBookedLists &&
      layoutObject.AllSeatDeatils &&
      layoutObject.LayoutStr
    ) {
      setAllSeatDeatils(layoutObject.AllSeatDeatils);
      setLayoutsArrayData(layoutObject.LayoutStr);
      setSeatBookedList(layoutObject.seatBookedLists);
      setIsLayoutDataLoading(false);

      setInterval(() => {
        setIsSeatFlipped((prevFlipped) => !prevFlipped);
      }, 2500);
    } else {
      //alert("All layout data not available");
    }
  }, [layoutObject]);

  useEffect(() => {
    // console.log("layouts list updated");
    // console.log(layoutsList);
  }, [layoutsList]);

  const handleTdClick = (id) => {
    // console.log(id);
    let pattern = `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-tdSeatID_`;
    // console.log(pattern);
    let extract_id = id.replace(pattern, "");
    // console.log(extract_id);

    //alert(layoutdata?.SeatIDs);
    // console.log(layoutdata?.SeatIDs);
    const seatObject = [...allSeatDeatils];
    let filteredSeat = seatObject.filter((item) => item.SeatID == extract_id);
    //alert("Seat Id is " + extract_id + "  the object is" + JSON.stringify(filteredSeat) );

    let seat_to_pick = filteredSeat?.length == 1 ? filteredSeat[0] : null;

    // console.log(selectedSeats.length);
    // if(selectedSeats.length > 5){

    // }else{
    //   console.log('asd');
    // }

    toggleSeatSelected(seat_to_pick);
  };

  // const handleTdClick = (id) => {
  //   console.log(id);
  //   let pattern = `ONWARD-${layoutdata?.CoachID}tdSeatID_`;
  //   console.log(pattern);
  //   let extract_id = id.replace(pattern, "");
  //   console.log(extract_id);

  //   //alert(layoutdata?.SeatIDs);
  //   console.log(layoutdata?.SeatIDs);
  //   const seatObject = [...layoutdata.SeatIDs];
  //   let filteredSeat = seatObject.filter((item) => item.SeatID == extract_id);
  //   //alert("Seat Id is " + extract_id + "  the object is" + JSON.stringify(filteredSeat) );

  //   let seat_to_pick = filteredSeat?.length == 1 ? filteredSeat[0] : null;

  //   console.log(selectedSeats.length);
  //   // if(selectedSeats.length > 5){

  //   // }else{
  //   //   console.log('asd');
  //   // }

  //   toggleSeatSelected(seat_to_pick);
  // };

  // useEffect(()=>{
  //     console.log(selectedSeats);
  // },[selectedSeats]);

  // useEffect(() => {
  //   fetchLayoutData();
  // }, []);

  // useEffect(() => {
  //   console.log(layoutdata);
  //   if (layoutdata) {
  //     // const parsedHtml = parse(layoutdata.rawLayoutStr);

  //     const rawString = layoutdata?.LayoutStr.replace(
  //       /##TDIDPREFIX##/g,
  //       "ONWARD-" + layoutdata?.CoachID
  //     );
  //     setLtd(rawString);
  //     const options = {
  //       replace: (node) => {
  //         if (node.type == "tag" && node.name == "td") {
  //           //console.log(node);
  //           return (
  //             <td
  //               rowSpan={node.attribs.rowspan}
  //               colSpan={node.attribs.colspan}
  //               style={{ minWidth: "40px" }}
  //             >
  //               {node.attribs.id === "ONWARD-1tdSeatID_0" ? (
  //                 <div> {node.children.map((p) => p.data)} </div>
  //               ) : (
  //                 <div
  //                   className={`${
  //                     node.attribs.id === "ONWARD-1tdSeatID_0"
  //                       ? ""
  //                       : node.attribs.rowspan == "3"
  //                       ? "seat seat-vertical"
  //                       : "seat"
  //                   }  ${
  //                     checkSeatSelected(node.attribs.id) ? "seat-checked" : ""
  //                   }`}
  //                   onClick={() => handleTdClick(node.attribs.id)}
  //                 >
  //                   {node.children.map((p) => p.data)}
  //                 </div>
  //               )}
  //             </td>
  //           );
  //         }
  //       },
  //     };

  //     const pdata = parse(rawString, options);

  //     setParsedData(pdata);
  //   }
  // }, [layoutdata, selectedSeats]);

  const selectedSeatIds = useMemo(
    () => new Set(selectedSeats.map((s) => s.SeatID)),
    [selectedSeats],
  );

  useEffect(() => {
    console.log(selectedSeatIds);
  }, [selectedSeatIds]);

  const bookedSeatIds = useMemo(
    () => new Set(seatsBookedList?.map((s) => s.SeatID)),
    [seatsBookedList],
  );

  const bookedSeatMap = useMemo(
    () => new Map(seatsBookedList?.map((s) => [s.SeatID, s])),
    [seatsBookedList],
  );

  const checkSeatSelected = useCallback(
    (id) => {
      const extract_id = id.replace(
        `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-tdSeatID_`,
        "",
      );
      //  console.log(selectedSeatIds)
      //  console.log(extract_id);
      //  console.log("THis is the select seat ");
      return selectedSeatIds.has(Number(extract_id));
    },
    [selectedSeatIds],
  );

  const checkIsSeatBooked = useCallback(
    (id) => {
      const extract_id = id.replace(
        `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-tdSeatID_`,
        "",
      );
      //  console.log(extract_id)
      //return bookedSeatIds?.has(Number(extract_id));

      const seat = bookedSeatMap.get(Number(extract_id));

      if (seat) {
        return seat.Gender;
      }

      return null;
    },
    [bookedSeatIds],
  );

  function replaceProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  function replaceBoardingProps(index) {
    return {
      id: `bd-tab-${index}`,
      "aria-controls": `bd-tabpanel-${index}`,
    };
  }

  const handleBoardingPointChange = (event) => {
    setSelectedBoarding(event.target.value);
    sendEventTobackend("BoardingPointSelected", null, 1);
    const bobj = pickupPoints.filter(
      (item) => item.BoardingPointID == event.target.value,
    );
    // console.log(bobj);
    if (bobj.length > 0) {
      setSelectedBoardingName(bobj[0]);
    }
    setTabBDValue(1);
    if(dialogContentRef.current){
      dialogContentRef.current.scrollTop = 0;
    }
  };

  const handleDroppingPointChange = (event) => {
    setSelectedDropping(event.target.value);
    sendEventTobackend("DroppingPointSelected", null, 1);
    const bobj = droppingPoints.filter(
      (item) => item.BoardingPointID == event.target.value,
    );
    // console.log(bobj);
    if (bobj.length > 0) {
      setSelectedDroppingName(bobj[0]);
    }
  };

  useEffect(() => {
    // console.log(selectedBoardingName);
    // console.log(selectedDroppingName);
  }, [selectedBoardingName, selectedDroppingName]);

  const toggleSeatSelected = (seat) => {
    setSelectedSeats((prev) =>
      prev?.some((s) => s.SeatID === seat.SeatID)
        ? prev.filter((item) => item.SeatID !== seat.SeatID)
        : prev.length > 5
          ? [...prev]
          : [...prev, seat],
    );
    sendEventTobackend("SeatsSelected", null, 1);
  };

  useEffect(() => {
    // console.log(selectedSeats);
    // const ordered_Seats = selectedSeats.orderBy(selectedSeats,["SeatNumber"],["asc"]);
    // setSelectedSeats(ordered_Seats);
    if (selectedSeats.length > 5) {
      alert("You can select maximum of 6 seats");
    }
    let sub_sum = 0;
    let discount = 0;
    let gst = 0;
    selectedSeats.forEach((seat) => {
      sub_sum += seat.FARE;
    });

    setSubTotal(sub_sum);
    setGrandwithoutDisc(sub_sum);
    setDiscount((sub_sum * discountInPercent) / 100);
    setTotalGst((sub_sum * gstInpercent) / 100);

    const seatsWithSelectedAttribe = selectedSeats.map((item) => ({
      ...item,
      passangerName: null,
      age: null,
      gender: false,
    }));
    console.log("Seats with additional attributes:");
    console.log(seatsWithSelectedAttribe);
    setUpdatedSeats(seatsWithSelectedAttribe);
  }, [selectedSeats]);

  useEffect(() => {
    setGrandTotal(0);
    const total = subtotal - discount;
    const gst = (total * gstInpercent) / 100;
    setTotalGst(gst);
    const grand_total = total + gst;
    setGrandTotal(grand_total);
  }, [selectedSeats, subtotal, discount, totalGst]);

  useEffect(() => {
    // console.log(updatedSeats);
  }, [updatedSeats]);

  useEffect(() => {
    console.log(pgselectorUrl);
  }, [pgselectorUrl]);

  const handleGenderChange = (SeatNumber) => {
    const currentValues = getValues();

    const seatsGenderUpdated = updatedSeats.map((seat, index) => {
      if (seat.SeatNumber === SeatNumber) {
        // Get passenger data from current form values
        const passengerData = currentValues.passengers?.[index] || {};

        return {
          ...seat,
          gender: !seat.gender,
          passangerName: passengerData.passangerName || seat.passangerName,
          age: passengerData.age || seat.age,
        };
      }
      return seat;
    });

    setUpdatedSeats(seatsGenderUpdated); // Make sure to update the state
  };

  const handleMaleIconClick = (SeatNumber) => {
    const currentValues = getValues();

    const seatsGenderUpdated = updatedSeats.map((seat, index) => {
      if (seat.SeatNumber === SeatNumber) {
        // Get passenger data from current form values
        const passengerData = currentValues.passengers?.[index] || {};

        return {
          ...seat,
          gender: false,
          passangerName: passengerData.passangerName || seat.passangerName,
          age: passengerData.age || seat.age,
        };
      }
      return seat;
    });

    setUpdatedSeats(seatsGenderUpdated);
  };

  const handleFeMaleIconClick = (SeatNumber) => {
    const currentValues = getValues();

    const seatsGenderUpdated = updatedSeats.map((seat, index) => {
      if (seat.SeatNumber === SeatNumber) {
        // Get passenger data from current form values
        const passengerData = currentValues.passengers?.[index] || {};

        return {
          ...seat,
          gender: true,
          passangerName: passengerData.passangerName || seat.passangerName,
          age: passengerData.age || seat.age,
        };
      }
      return seat;
    });

    setUpdatedSeats(seatsGenderUpdated);
  };

  useEffect(() => {
    // console.log(selectedGender);
  }, [selectedGender]);

  const handleBDChange = (event, newValue) => {
    setTabBDValue(newValue);
  };

  const swipehandlers = useSwipeable({
    onSwipedLeft: () => {
      // console.log("left swiped");
      setTabBDValue(1);
    },
    onSwipedRight: () => {
      // console.log("right swiped");
      setTabBDValue(0);
    },
    swipeDuration: 500,
    preventScrollOnSwipe: true,
    trackMouse: true,
  });

  const handleBookNow = () => {
    // window.location.href = `${paymentUrl}`
    // window.location.replace(paymentUrl);
  };

  const inputRefs = useRef({});
  const onInvalid = (errors) => {
    // Find the first key in the errors object
    const firstErrorField = Object.keys(errors)[0];

    if (firstErrorField && inputRefs.current[firstErrorField]) {
      // Get the actual DOM element reference
      const element = inputRefs.current[firstErrorField];

      // Use the browser API to scroll it into view smoothly
      element.scrollIntoView({ behavior: "smooth", block: "center" });

      // Optional: focus the element as well
      element.focus();
    }
  };

  // passenger details payload creation

  const onSubmit = (formData) => {
    if (!isTermsAndConditionsChecked) {
      alert("Please accept the terms and conditions to proceed.");
      document
        .getElementById("termsAndConditions")
        .scrollIntoView({ behavior: "smooth", block: "center" });
      return;
    }
    sendEventTobackend("BookNowCliked", null, 1);
    console.log("     ");
    // formData contains: { mobile, email, passengers: [{name, age}, ...] }

    // Merge passenger form values into updatedSeats
    // const mergedSeats = updatedSeats.map((seat, idx) => ({
    //   ...seat,
    //   passangerName: formData.passengers?.[idx]?.passangerName ?? "",
    //   age: formData.passengers?.[idx]?.age ?? "",
    // }));

    //console.log(formData);
    // console.log(updatedSeats);

    alert("I am Clicked");

    var isLogged = 0;
    var loggedMobileNo = "";


    

    console.log(globalData);
    if (globalData.SignedPassenger) {
      isLogged = globalData.SignedPassenger?.IsPassengerSignedIn;
      loggedMobileNo = globalData.SignedPassenger.SignedPassenger?.MobileNumber;
    }

    var deviceId = null;
    var deviceDaySession = null;

    if (
      PlatformDetector.isAndroidWebView() ||
      PlatformDetector.isIOSWebView()
    ) {

      console.log("window APP State data is ", window.__APP_STATE__);
      if(window.__APP_STATE__){
        isLogged = window.__APP_STATE__.IsPassengerSignedIn;
        loggedMobileNo = window.__APP_STATE__.SignedPassenger?.MobileNumber;
      }

      

      

      if (window.RegistrationUniqueIDFromMobile) {
        deviceId = window.RegistrationUniqueIDFromMobile;
      }

      if (window.SessionUniqueIDFromMobile) {
        deviceDaySession = { sessionId: window.SessionUniqueIDFromMobile };
      }
    } else {
      if (window.SessionConstants.DEVICE_INFO_KEY) {
        deviceId = localStorage.getItem(
          window.SessionConstants.DEVICE_INFO_KEY,
        );
      }

      if (window.SessionConstants.DEVICE_SESSION_KEY) {
        deviceDaySession = JSON.parse(
          localStorage.getItem(window.SessionConstants.DEVICE_SESSION_KEY),
        );
      }
    }

    const mergedSeats = updatedSeats.map((seat, idx) => ({
      SeatName: seat.SeatNumber,
      SeatID: seat.SeatID,
      SeatFare: seat.FARE,
      SeatCUTFare: "0",
      SelectedName: formData.passengers?.[idx]?.passangerName ?? "",
      SelectedGender: seat.gender === true ? 2 : 1,
      SelectedAge: formData.passengers?.[idx]?.age ?? "",
    }));

    //setUpdatedSeats(mergedSeats);
    console.log("Form data GST Number is " + formData.GSTNumber);
    setContactDetails({ mobile: formData.mobile, email: formData.email });

    const payload = {
      GATEWAYNumber: 1,
      OnwardBookingDetails: {
        JType: 1,
        JourneyID: currentJourneyId,
        FromCityID: currentFromCityId,
        ToCityID: currentToCityId,
        BoardingPointID: selectedBoarding,
        DropingPointID: selectedDropping,
        ContactNumber: formData.mobile,
        ContactEmail: formData.email,
        GSTNumber: formData.GSTNumber != undefined ? formData.GSTNumber : "",
        seatsSelected: mergedSeats,
        TRVia: deviceType,
        MISBookingMode: MISBookingModeSate,
        RegistrationUniqueID: deviceId || "iosempty",
        SessionUniqueID: deviceDaySession?.sessionId || "iossessempty",
        IsPassengerSignedIn: isLogged,
        SignedPassengerMobileNumber:
          isLogged == 1
            ? loggedMobileNo != null || loggedMobileNo != undefined
              ? loggedMobileNo
              : ""
            : "",
      },
      ReturnBookingDetails: {
        JType: "0",
        JourneyID: "0",
        RegistrationUniqueID: deviceId || "iossessempty",
        SessionUniqueID: deviceDaySession?.sessionId || "iosempty",
        IsPassengerSignedIn: isLogged,
        SignedPassengerMobileNumber:
          isLogged == 1
            ? loggedMobileNo != null || loggedMobileNo != undefined
              ? loggedMobileNo
              : ""
            : "",
      },
    };

    if (
      paths.alterSeatBookingInfo != "" &&
      paths.alterSeatBookingInfo != null &&
      paths.alterSeatBookingInfo != undefined
    ) {
      console.log("Alert seat booking info is " + paths.alterSeatBookingInfo);
      alert("Alert: " + paths.alterSeatBookingInfo);

      payload.seatBookingAlterRequest = JSON.parse(paths.alterSeatBookingInfo);
    }

    console.log(payload);
    alert(JSON.stringify(payload));

    var selectors = null;

    if (
      PlatformDetector.isAndroidWebView() ||
      PlatformDetector.isIOSWebView()
    ) {
      selectors = {
        PGSelectionType: 1,
        PGTransactionVia: 1,
        GatewayNumber: 0,
        OrchestratorNumber: 3,
        isFromApp:
          PlatformDetector.isAndroidWebView() || PlatformDetector.isIOSWebView()
            ? 1
            : 0,
      };
    } else {
      selectors = {
        PGSelectionType: 1,
        PGTransactionVia: 1,
        GatewayNumber: 0,
        OrchestratorNumber: 3,
        isFromApp:
          PlatformDetector.isAndroidWebView() || PlatformDetector.isIOSWebView()
            ? 1
            : 0,
      };
    }

    if (
      PlatformDetector.isAndroidWebView() ||
      PlatformDetector.isIOSWebView()
    ) {
      setIsLoading(true);
      console.log("this is the web view  part here ");
      axios
        .post(
          `${"/" + paths.BookSeatsTempEndPoint + "?" + getPgSelectorUrlString(selectors)}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        )
        .then((res) => {
          // console.log(res.data);
          let response = res.data;

          console.log("response Data is" + JSON.stringify(response));
          //alert("response Data is" + JSON.stringify(response));

          if (response) {
            if (response.Status) {
              // let res = JSON.parse(response.ResponseData);

              //    //console.log(response.ResponseData);
              //    //console.log(paths.redirectToPg);
              setTimeout(() => {
                //setIsLoading(false);
              }, [10000]);

              //     console.log( JSON.parse( response.ResponseData ) );
              const resultantdata =
                typeof response.ResponseData === "string"
                  ? JSON.parse(response.ResponseData)
                  : response.ResponseData;

              if (
                resultantdata.TEMPORDERID != null &&
                resultantdata.TEMPORDERID != undefined
              ) {
                const pmSession = JSON.parse(resultantdata.GatewayOrderSession);
                if (selectors.PGSelectionType == 1) {
                  if (selectors.OrchestratorNumber == 3) {
                    window.ReactNativeWebView.postMessage(
                      JSON.stringify({
                        messageType: "operation",
                        action: "book_seats",
                        payload: pmSession,
                        pgselector: selectors,
                      }),
                    );
                  } else {
                    window.ReactNativeWebView.postMessage(
                      JSON.stringify({
                        messageType: "operation",
                        action: "Invalid selection",
                      }),
                    );
                  }
                } else {
                  window.ReactNativeWebView.postMessage(
                    JSON.stringify({
                      messageType: "operation",
                      action: "Invalid selection",
                    }),
                  );
                }
              } else {
                console.log(
                  "Else part of this " + JSON.stringify(resultantdata),
                );
                console.log("condition is  " + JSON.stringify(resultantdata));

                console.log(
                  "condition is  " +
                    (resultantdata.TransactionPassed !== undefined &&
                      resultantdata.TransactionPassed !== null),
                );

                if (
                  resultantdata.TransactionPassed !== undefined &&
                  resultantdata.TransactionPassed !== null
                ) {
                  window.ReactNativeWebView.postMessage(
                    JSON.stringify({
                      messageType: "operation",
                      action: "postphone_seats",
                      payload: JSON.stringify(resultantdata),
                      pgselector: "none",
                    }),
                  );
                  console.log(
                    "Postpone or prepone flow data " +
                      JSON.stringify(resultantdata),
                  );
                  // window.location.replace(`${paths.postponeOrpreponeResultUrl}?transaction=${urldata.toString()}`);
                } else {
                  alert(resultantdata.message);
                }
              }

              //console.log("small scr data. ");

              //alert("temp order Id" + reultantdata.TEMPORDERID);

              //     console.log("Payment session data ");
              //     console.log(pmSession);

              //   //  window.location.href=`${globalData.ServerBaseUrl+paths.redirectToPg+response.ResponseData.TEMPORDERID}`;
            } else {
              setIsLoading(false);
              alert(response.Message);
            }
          } // if response
          else {
            console.log("Response Deos not exist");
          }
          //if (res.data) {
          //   if(res.data.data.Status){
          //       if(res.data.data.ResponseData){
          //         let res = JSON.parse(res.data.data.ResponseData);
          //         console.log(res);
          //       }
          //   }else{
          //     alert(res.data.data.Message);
          //   }
          //}
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("Error in booking seats " + err.toString());
          //alert(err.toString());
        });

      // return;
    } else {
      setIsLoading(true);
      console.log("this is the not web v  part here ");
      axiosInstance
        .post(
          `${"/" + paths.BookSeatsTempEndPoint + "?" + getPgSelectorUrlString(selectors)}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        )
        .then((res) => {
          // console.log(res.data);
          let response = res.data;
          if (response) {
            console.log(response.ResponseData);
            if (response.Status) {
              // let res = JSON.parse(response.ResponseData);

              console.log("Status is true");

              //console.log(response.ResponseData);
              //console.log(paths.redirectToPg);
              setTimeout(() => {
                //setIsLoading(false);
              }, [2000]);

              const resultantdata =
                typeof response.ResponseData === "string"
                  ? JSON.parse(response.ResponseData)
                  : response.ResponseData;

              if (
                resultantdata.TEMPORDERID != null &&
                resultantdata.TEMPORDERID != undefined
              ) {
                window.location.href = `${globalData.ServerBaseUrl + paths.redirectToPg + resultantdata.TEMPORDERID}`;
              } else {
                console.log(
                  "This is else part in web " + JSON.stringify(resultantdata),
                );

                console.log(
                  "Else part in web small screen " +
                    JSON.stringify(resultantdata),
                );
                console.log(
                  "condition is  in web small screen" +
                    JSON.stringify(resultantdata),
                );

                console.log(
                  "condition is  " +
                    (resultantdata.TransactionPassed !== undefined &&
                      resultantdata.TransactionPassed !== null),
                );

                if (
                  resultantdata.TransactionPassed !== undefined &&
                  resultantdata.TransactionPassed !== null
                ) {
                  const urldata = new URLSearchParams(resultantdata);
                  window.location.replace(
                    `${paths.postponeOrpreponeResultUrl}?transaction=${urldata.toString()}`,
                  );
                } else {
                  alert(resultantdata.message);
                }
              }
            } else {
              setIsLoading(false);
              alert(response.Message);
            }

            // if (res.data) {
            //   if (res.data.data.Status) {
            //     if (res.data.data.ResponseData) {
            //       let res = JSON.parse(res.data.data.ResponseData);
            //       console.log(res);
            //     }
            //   } else {
            //     //alert(res.data.data.Message);
            //   }
            // }
          } else {
            console.log("No response In Web");
          }
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("Error in booking seats " + err.toString());
          //alert(err.toString());
        });
    }

    // console.log(payload);
    // setFormPayload(payload);
    // alert(JSON.stringify(payload));

    // continue to payment
    // handleBookNow(); // or your window.location.replace(paymentUrl)
  };

  useEffect(() => {
    // console.log(frompayload);
    // console.log(formref.current);
    if (frompayload != null && formref.current) {
      formref.current.submit();
    }
  }, [frompayload]);



  const handleLocationClick = (lat=15.350417344847436,lon=75.1391945019891) => {

    const url = `/show-pickup-dropping?lat=${lat}&lon=${lon}`;
     if (
      PlatformDetector.isAndroidWebView() ||
      PlatformDetector.isIOSWebView()
    ){

          window.ReactNativeWebView.postMessage(
                      JSON.stringify({
                        messageType: "operation",
                        action: "locationButtonClick",
                        payload: {lat:lat,lon:lon,url:url},
                        }),
                    );

    }else{
        window.open(url, '_blank');
    }

  }

  return (
    <>
      {/* <button onClick={() => setDailogOpen((prev) => (prev = !prev))}>
        open/close dailog
      </button> */}

      <Fragment>
        <Dialog
          fullWidth
          open={open}
          onClose={handleClose}
          slots={{
            transition: TransitionDialog,
          }}
          PaperProps={{
            sx: {
              m: 0,
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              width: "100vw",
              maxWidth: "100vw",
              height: "100%",
              maxHeight: "100%",
              overflowY: "hidden",
            },
          }}
        >
           <AppBar
  sx={{
    padding: "2px 10px",
    position: "relative",
    background: "#F4CC08",
    boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
  }}
>
  <Toolbar
    sx={{
      background: "#F4CC08",
      display: "flex",
      justifyContent: "space-between",
      width: '100%',
      gap: "20px" /* Prevents the text from crashing into the close button */
    }}
  >
    {/* ADDED flexGrow: 1 HERE TO STRETCH THE CONTAINER */}
    <div className="flip-button-dialog" style={{ flexGrow: 1, minWidth: 0 }}>
      <div className="flip-container-dialog flip-animation-dialog">
        <div className="flip-inner-dialog">
          <div className="flip-front-dialog">
            <Typography
              sx={{
                color: "#1f1f1f",
                fontWeight: "600",
                width: "100%",
                fontSize: `${dailogInputData?.bus.CoachExternal.length > 32 ? "12px" : "16px"}`,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis" /* Graceful truncation if text is massive */
              }}
            >
              {dailogInputData?.bus.CoachExternal}
            </Typography>
            <Typography
              sx={{
                color: "#1f1f1f",
                fontWeight: "600",
                width: "100%",
              }}
            >
              <small>
                {dailogInputData?.bus.BoardingCity +
                  "-" +
                  dailogInputData?.bus.DropCity}
              </small>
            </Typography>
          </div>
          <div className="flip-back-dialog">
            <Typography
              sx={{
                color: "#1f1f1f",
                fontWeight: "600",
                width: "100%",
              }}
            >
              {onwardDateFormatWithMonthName}
            </Typography>
            <Typography
              sx={{
                color: "#1f1f1f",
                fontWeight: "600",
                width: "100%",
              }}
            >
              {onwardDayName}
            </Typography>
          </div>
        </div>
      </div>
    </div>

    <div style={{ display: "flex", alignItems: "center" }}>
      <IconButton
        edge="end"
        onClick={handleClose}
        aria-label="close"
        sx={{
          color: "#1f1f1f",
          border: "1px solid #1f1f1f",
          borderRadius: "50%",
          "&:hover": {
            color: "#fff",
            backgroundColor: "#1f1f1f",
          },
          height: "30px",
          width: "30px",
        }}
      >
        <IoMdClose />
      </IconButton>
    </div>
  </Toolbar>
</AppBar>


          <Box
            sx={{
              borderBottom: 1,
              borderColor: "#2D3FA8",
              borderWidth: "2px",
              padding: 0,
              margin: 0,
              height: "35px",
              minHeight: "35px",
            }}
          >
            <Tabs
              value={tabValue}
              aria-label="basic tabs example"
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              TabIndicatorProps={{ style: { display: "none" } }}
            >
              <Tab sx={tabstyles} label="View Seats" {...replaceProps(0)} />
              <Tab
                sx={tabstyles}
                label="Boarding / Dropping Point"
                {...replaceProps(1)}
              />
              <Tab
                sx={tabstyles}
                label="Passenger Information"
                {...replaceProps(2)}
              />
              <Tab sx={tabstyles} label="Bus Route" {...replaceProps(3)} />
              <Tab sx={tabstyles} label="About Bus" {...replaceProps(4)} />
            </Tabs>
          </Box>

          <DialogContent
             ref={dialogContentRef}
            sx={{
              m: 0,
              p: "5px",
              display: "flex",
              flex: 1,
              justifyContent: "center",
            }}
          >
            <div className="dialog-tabpanes-content">
              <CustomTabPanel value={tabValue} index={0}>
                {isLayoutDataLoading ? (
                  <SeatLayoutVerticalSkeleton />
                ) : (
                  <div className="seat-layout-content">
                    <div
                      className={
                        layoutOrientation == 1
                          ? "seat-layout"
                          : "seat-layout-vertical"
                      }
                    >
                      {layoutsList &&
                        layoutsList.length > 0 &&
                        layoutsList.map((layoutItem, index) => (
                          <div
                            key={index}
                            style={{ marginTop: "20px" }}
                            className={
                              layoutOrientation == 1
                                ? "layout-deck-content"
                                : "layout-deck-content-vertical"
                            }
                          >
                            <div className="busfront">
                              <div className="driver-seat">
                                {layoutItem.DeckName === "Lower Deck" ? (
                                  <GiSteeringWheel
                                    size={20}
                                    className="steering-icon"
                                  />
                                ) : (
                                  <div style={{ paddingLeft: "16px", width:"20px",height: "25px" }}>&nbsp;</div>
                                )}
                              </div>
                              <div className="deck-name">
                                {layoutItem.DeckName}
                              </div>
                            </div>
                            <div>
                              {layoutItem.parsedData && layoutItem.parsedData}
                            </div>
                          </div>
                        ))}
                    </div>
                    {/* <div className="seat-layout-seat-info">
                    
                    <div className="seat-items-info">
                      <span> Available </span>
                      <div>
                         <div className="seat-info-empty-seat-mobile">
                            <div className="slot"></div>
                         </div>
                      </div>
 
                    </div>


                    <div className="seat-items-info">
                       <span>Selected</span>
                      <div>
                         <div className="seat-info-empty-seat-mobile selected-seat">
                            <div className="slot"></div>
                         </div>
                      </div>

                    </div>
                    <div className="seat-items-info">
                      <span>Booked</span>
                      <div>
                         <div className="seat-info-empty-seat-mobile booked-seat">
                            <div className="slot"></div>
                         </div>
                      </div>

                    </div>
                    
                  
                  </div> */}

                    <div className="seat-info">
                      <div className="seat-layout-seat-info">
                        <div className="seat-items-info-large">
                          <span> Available </span>
                          <div>
                            <div className="seat-info-empty-seat-large">
                              <div className="slot"></div>
                            </div>
                          </div>
                        </div>

                        <div className="seat-items-info-large">
                          <span> Selected </span>
                          <div>
                            <div className="seat-info-empty-seat-large selected-seat">
                              <div className="slot"></div>
                            </div>
                          </div>
                        </div>

                        <div className="seat-items-info-large">
                          <span> Booked </span>
                          <div>
                            <div className="seat-info-empty-seat-large booked-seat">
                              <div className="slot"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* <div
                className="dialog-bottom-group"
               >
                {selectedSeats?.length > 0 && (
                  <button
                    className="continue-button"
                    onClick={() => setTabValue(1)}
                  >
                    {" "}
                    Continue{" "}
                  </button>
                )}
              </div> */}
              </CustomTabPanel>

              <CustomTabPanel value={tabValue} index={1} {...swipehandlers}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                  }}
                >
                  <Tabs
                    sx={{ maxHeight: "35px", height: "35px" }}
                    value={tabBDValue}
                    onChange={handleBDChange}
                    TabIndicatorProps={{ style: { display: "none" } }}
                    centered
                  >
                    <Tab
                      sx={tabBDstyles}
                      label={"Boarding Points"}
                      {...replaceBoardingProps(0)}
                    ></Tab>
                    <Tab
                      sx={tabBDstyles}
                      label={"Dropping Points"}
                      {...replaceBoardingProps(1)}
                    ></Tab>
                  </Tabs>
                </Box>

                <Box sx={{ minHeight: "300px", padding: "0px" }}>
                  <CustomBDTabPanel value={tabBDValue} index={0}>
                    <div className="dialog-board-drop-container-smallscreen">
                      <div className="dialog-boarding-points"
                      
                          style={{ maxHeight:"75vh",  overflowY: "auto", overscrollBehavior: "contain" }}
                      
                      >
                        <h3 className="headings-main">Select Boarding Point</h3>
                        <small></small>

                        {pickupPoints &&
                          pickupPoints.map((item, index) => (
                            <div className="dialog-input-containers">
                              <div className="dialog-input-radio">
                                <div className="inputs-content">
                                  <label
                                    className="radio-label"
                                    key={item.BoardingPointID + "-" + index}
                                  >
                                    <div>
                                      <input
                                        type="radio"
                                        name="boardings"
                                        value={item.BoardingPointID}
                                        id={item.BoardingPointID + "-" + index}
                                        checked={
                                          selectedBoarding ===
                                          item.BoardingPointID
                                        }
                                        onChange={handleBoardingPointChange}
                                      />
                                      <span> {item.DepartureTime}</span>
                                    </div>

                                    <span className="pointname">
                                      {item.PointName}
                                    </span>
                                  </label>
                                </div>

                                <div className="br-details" onClick={() =>
                                      handleBoardingPointChange({
                                        target: { value: item.BoardingPointID },
                                      })
                                    }>
                                  <div className="left-content-br">
                                    <div className="content-bottom">
                                      {/* {item.ContactMobileNumber != "" ? (
                                        <div className="mobile-number">
                                          <a
                                            href={
                                              "tel:" + item.ContactMobileNumber
                                            }
                                          >
                                            <CiPhone />{" "}
                                            <>
                                              {item.ContactMobileNumber}{" "}
                                            </>{" "}
                                          </a>{" "}
                                          &nbsp;
                                        </div>
                                      ) : (
                                        ""
                                      )} */}

                                      

                                      <div className="icons-container">
                                        <a className="location-button" onClick={(e)=>{e.stopPropagation(); handleLocationClick();}}  >
                                          <CiLocationOn />
                                        </a>

                                        {/* <span className="location-button">
                                          <TbView360Number />
                                        </span> */}
                                      </div>


                                      <ContactPhone mobileNumber={item.ContactMobileNumber} />
                                    </div>
                                  </div>

                                  <div
                                    className="right-content-br"
                                    
                                  >
                                    <span>
                                      {item.LandMark1 !== ""
                                        ? item.LandMark1
                                        : ""}
                                    </span>
                                    <span>
                                      {item.LandMark2 !== ""
                                        ? item.LandMark2
                                        : ""}
                                    </span>
                                    <span>
                                      {item.AddressLine1 !== ""
                                        ? item.AddressLine1
                                        : ""}
                                    </span>
                                    <span>
                                      {item.AddressLine2 !== ""
                                        ? item.AddressLine2
                                        : ""}
                                    </span>
                                    <span>
                                      {item.AddressLine3 !== ""
                                        ? item.AddressLine3
                                        : ""}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}

                         <div style={{ height: "200px",paddingBottom: "150px" }}></div>
                         <div style={{ height: "200px",paddingBottom: "150px" }}></div>
                      </div>
                    </div>
                  </CustomBDTabPanel>

                  <CustomBDTabPanel value={tabBDValue} index={1}>
                    <div className="dialog-board-drop-container-smallscreen">
                      <div className="dialog-dropping-points"
                        
                        style={{ maxHeight:"75vh", overflowY: "auto", overscrollBehavior: "contain" }}
                      
                      > 
                        <h3 className="headings-main">
                          Select Dropping Points
                        </h3>
                        <small></small>
                        {droppingPoints &&
                          droppingPoints.map((item, index) => (
                            <div className="dialog-input-containers">
                              <div className="dialog-input-radio">
                                <div className="inputs-content-dropping">
                                  <label
                                    className="radio-label"
                                    key={
                                      item.BoardingPointID +
                                      "-" +
                                      index +
                                      "dropping"
                                    }
                                  >
                                    <span className="pointname">
                                      {item.PointName}
                                    </span>

                                    <div>
                                      <span> {item.ArrivalTime}</span>
                                      <input
                                        type="radio"
                                        name="droppings"
                                        value={item.BoardingPointID}
                                        id={item.BoardingPointID + "-" + index}
                                        checked={
                                          selectedDropping ===
                                          item.BoardingPointID
                                        }
                                        onChange={handleDroppingPointChange}
                                      />
                                    </div>
                                  </label>
                                </div>

                                <div className="dr-details"  onClick={() =>
                                      handleDroppingPointChange({
                                        target: { value: item.BoardingPointID },
                                      })
                                    }>
                                  <div
                                    className="right-content-br"
                                    
                                  >
                                    <span>
                                      {item.LandMark1 !== ""
                                        ? item.LandMark1
                                        : ""}
                                    </span>
                                    <span>
                                      {item.LandMark2 !== ""
                                        ? item.LandMark2
                                        : ""}
                                    </span>
                                    <span>
                                      {item.AddressLine1 !== ""
                                        ? item.AddressLine1
                                        : ""}
                                    </span>
                                    <span>
                                      {item.AddressLine2 !== ""
                                        ? item.AddressLine2
                                        : ""}
                                    </span>
                                    <span>
                                      {item.AddressLine3 !== ""
                                        ? item.AddressLine3
                                        : ""}
                                    </span>
                                  </div>
                                  <div className="left-content-br">
                                    <div className="content-bottom">
                                     

                                      {/* {item.ContactMobileNumber != "" ? (
                                        <div className="mobile-number">
                                          <a
                                            href={
                                              "tel:" + item.ContactMobileNumber
                                            }
                                          >
                                            <CiPhone />{" "}
                                            <>
                                              {item.ContactMobileNumber}{" "}
                                            </>{" "}
                                          </a>{" "}
                                          &nbsp;
                                        </div>
                                      ) : (
                                        ""
                                      )} */}

                                      <ContactPhone mobileNumber={item.ContactMobileNumber} />

                                      <div className="icons-container">
                                        <a className="location-button" onClick={(e)=>{e.stopPropagation(); handleLocationClick();}} >
                                          <CiLocationOn />
                                        </a>

                                        {/* <span className="location-button">
                                          <TbView360Number />
                                        </span> */}
                                      </div>
                                    </div>
                                  </div>

                                  
                                </div>
                              </div>
                            </div>
                          ))}

                         <div style={{ height: "200px",paddingBottom: "150px" }}></div>
                         <div style={{ height: "200px",paddingBottom: "150px" }}></div>
                         
                      </div>
                    </div>
                  </CustomBDTabPanel>
                </Box>
              </CustomTabPanel>

              <CustomTabPanel value={tabValue} index={2}>
                <div className="passanger-detiales-content" ref={passengerSectionRef}  style={{ width: "100%", maxHeight: "90vh", overflowY: "auto", overscrollBehavior: "contain" }}>
                  {selectedSeats?.length > 0 &&
                  selectedBoarding != null &&
                  selectedDropping != null ? (
                    <>
                      <div className="customer-info-small-screen">
                        <h3 className="headings-main">Contact Details</h3>
                        <div className="contact-details-card">
                          <div >
                            <Controller
                              name="mobile"
                              control={control}
                              rules={{
                                required: "Mobile number is required",
                                pattern: {
                                  value: /^[0-9]{10}$/,
                                  message:
                                    "Enter a valid 10-digit mobile number",
                                },
                              }}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  inputRef={(el) => {
                                    field.ref(el); // Still let RHF manage its own ref internally
                                    inputRefs.current.mobile = el; // Manually track it for our scroll logic
                                  }}
                                  onBlur={(e) => {
                                    field.onBlur();
                                    const value = e.target.value;
                                    sendEventTobackend(
                                      "ContactMobileNoTouched",
                                      null,
                                      1,
                                    );
                                  }}
                                  placeholder="Mobile Number *"
                                  variant="outlined"
                                  label="Mobile Number *"
                                  size="small"
                                  fullWidth
                                  error={!!errors.mobile}
                                  helperText={errors.mobile?.message}
                                  inputProps={{
                                    maxLength: 10,
                                    autoComplete: "none",
                                    inputMode: "numeric",
                                    pattern: "[0-9]*",
                                  }}
                                  sx={{
                                    "& .MuiInputLabel-root": {
                                      fontSize: "13px",
                                      "&.Mui-focused": {
                                        color: "#2D3FA8",
                                      },
                                    },

                                    "& .MuiOutlinedInput-root": {
                                      maxHeight: "40px",

                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#B7B7B7",
                                        borderWidth: "1px",
                                      },

                                      "&:hover .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "",
                                        },

                                      "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "#B7B7B7",
                                          borderWidth: "1px",
                                        },
                                    },

                                    "& label.Mui-focused": {
                                      color: "#1F1F1F",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>

                          <div style={{ width: "100%" }}>
                            <Controller
                              name="email"
                              control={control}
                              rules={{
                                required: "Email is required",
                                pattern: {
                                  value: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
                                  message: "Enter a valid email address",
                                },
                              }}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  inputRef={(el) => {
                                    field.ref(el); // Still let RHF manage its own ref internally
                                    inputRefs.current.email = el; // Manually track it for our scroll logic
                                  }}
                                  onBlur={(e) => {
                                    field.onBlur();
                                    const value = e.target.value;
                                    sendEventTobackend(
                                      "ContactEmailTouched",
                                      null,
                                      1,
                                    );
                                  }}
                                  placeholder="E-mail *"
                                  label="Email *"
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  error={!!errors.email}
                                  helperText={errors.email?.message}
                                  inputProps={{ autoComplete: "none" }}
                                  sx={{
                                    "& .MuiInputLabel-root": {
                                      fontSize: "13px",
                                      "&.Mui-focused": {
                                        color: "#2D3FA8",
                                      },
                                    },

                                    "& .MuiOutlinedInput-root": {
                                      maxHeight: "40px",

                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#B7B7B7",
                                        borderWidth: "1px",
                                      },

                                      "&:hover .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "",
                                        },

                                      "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "#B7B7B7",
                                          borderWidth: "1px",
                                        },
                                    },

                                    "& label.Mui-focused": {
                                      color: "#1F1F1F",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>

                          <div style={{ width: "100%" }}>
                            <Controller
                              name="GSTNumber"
                              control={control}
                              rules={{
                                pattern: {
                                  value: /^[a-zA-Z0-9]{15}$/,
                                  //  exact gst pattern match
                                  //  /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1}$/
                                  message: "Enter a valid GST number",
                                },
                              }}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  inputRef={(el) => {
                                    field.ref(el); // Still let RHF manage its own ref internally
                                    inputRefs.current.GSTNumber = el; // Manually track it for our scroll logic
                                  }}
                                  onBlur={(e) => {
                                    field.onBlur();
                                    const value = e.target.value;
                                    sendEventTobackend(
                                      "ContactGSTNumberTouched",
                                      null,
                                      1,
                                    );
                                  }}
                                  placeholder="GST Number "
                                  label="GST Number "
                                  variant="outlined"
                                  size="small"
                                  fullWidth
                                  error={!!errors.GSTNumber}
                                  helperText={errors.GSTNumber?.message}
                                  inputProps={{ autoComplete: "none" }}
                                  sx={{
                                    "& .MuiInputLabel-root": {
                                      fontSize: "13px",
                                      "&.Mui-focused": {
                                        color: "#2D3FA8",
                                      },
                                    },

                                    "& .MuiOutlinedInput-root": {
                                      maxHeight: "40px",

                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#B7B7B7",
                                        borderWidth: "1px",
                                      },

                                      "&:hover .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "",
                                        },

                                      "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                        {
                                          borderColor: "#B7B7B7",
                                          borderWidth: "1px",
                                        },
                                    },

                                    "& label.Mui-focused": {
                                      color: "#1F1F1F",
                                    },
                                  }}
                                />
                              )}
                            />
                          </div>

                          <small style={{ color: "red", paddingLeft: "0px" }}>
                            Journey & Ticket Details will be sent these details!
                          </small>
                        </div>
                      </div>
                      <h3 className="headings-main">Passanger Details</h3>

                      <div className="passenger-details-small">
                        {updatedSeats?.map((item, index) => (
                          <div
                            className="passenger-card-container-small"
                            key={index}
                          >
                            <div className="card-top-button">
                              {" "}
                              {item.SeatNumber}{" "}
                            </div>
                            <div className="passenger-card-small">
                              <div>
                                <Controller
                                  name={`passengers.${index}.passangerName`}
                                  control={control}
                                  rules={{
                                    required: "Name is required",
                                    pattern: {
                                      value: /^[a-zA-Z ]*$/,
                                      message: "Enter valid Name",
                                    },
                                    minLength: {
                                      value: 2,
                                      message: "Enter a valid name",
                                    },
                                  }}
                                  render={({ field }) => (
                                    <TextField
                                      {...field}
                                      inputRef={(el) => {
                                        field.ref(el); // Still let RHF manage its own ref internally
                                        inputRefs.current.passangerName = el; // Manually track it for our scroll logic
                                      }}
                                      placeholder="Passenger Name *"
                                      variant="outlined"
                                      label="Passenger Name *"
                                      size="small"
                                      inputProps={{ autoComplete: "none" }}
                                      onChange={(e) => {
                                        field.onChange(e); // update react-hook-form
                                        const newSeats = [...updatedSeats];
                                        if (newSeats[index]) {
                                          newSeats[index].passangerName =
                                            e.target.value;
                                          setUpdatedSeats(newSeats); // sync with updatedSeats
                                        }
                                      }}
                                      onBlur={(e) => {
                                        field.onBlur();
                                        const value = e.target.value;
                                        sendEventTobackend(
                                          "PassengerNameTouched",
                                          null,
                                          1,
                                        );
                                      }}
                                      error={
                                        !!(
                                          errors.passengers &&
                                          errors.passengers[index]
                                            ?.passangerName
                                        )
                                      }
                                      helperText={
                                        errors.passengers &&
                                        errors.passengers[index]?.passangerName
                                          ?.message
                                      }
                                      fullWidth
                                      sx={{
                                        "& .MuiInputLabel-root": {
                                          fontSize: "13px",
                                          "&.Mui-focused": {
                                            color: "#2D3FA8",
                                          },
                                        },

                                        "& .MuiOutlinedInput-root": {
                                          maxHeight: "40px",

                                          "& .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "#B7B7B7",
                                              borderWidth: "1px",
                                            },

                                          "&:hover .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "",
                                            },

                                          "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "#B7B7B7",
                                              borderWidth: "1px",
                                            },
                                        },

                                        "& label.Mui-focused": {
                                          color: "#1F1F1F",
                                        },
                                      }}
                                    />
                                  )}
                                />
                              </div>

                              <div className="age-gnder-price-small">
                                <div>
                                  <Controller
                                    name={`passengers.${index}.age`}
                                    control={control}
                                    rules={{
                                      required: "Age is required",
                                      pattern: {
                                        value: /^[0-9]{1,3}$/,
                                        message: "Enter valid age",
                                      },
                                      validate: (v) =>
                                        (Number(v) > 0 && Number(v) < 130) ||
                                        "Enter valid age",
                                    }}
                                    render={({ field }) => (
                                      <TextField
                                        {...field}
                                        inputRef={(el) => {
                                          field.ref(el); // Still let RHF manage its own ref internally
                                          inputRefs.current.age = el; // Manually track it for our scroll logic
                                        }}
                                        label="Age *"
                                        placeholder="Age *"
                                        variant="outlined"
                                        size="small"
                                        error={
                                          !!(
                                            errors.passengers &&
                                            errors.passengers[index]?.age
                                          )
                                        }
                                        helperText={
                                          errors.passengers &&
                                          errors.passengers[index]?.age?.message
                                        }
                                        inputProps={{
                                          inputMode: "numeric",
                                          pattern: "[0-9]*",
                                          maxLength: 3,
                                          autoComplete: "none",
                                        }}
                                        onChange={(e) => {
                                          field.onChange(e); // update react-hook-form
                                          const newSeats = [...updatedSeats];
                                          if (newSeats[index]) {
                                            newSeats[index].age =
                                              e.target.value;
                                            setUpdatedSeats(newSeats); // sync with updatedSeats
                                          }
                                        }}
                                        onBlur={(e) => {
                                          field.onBlur();
                                          const value = e.target.value;
                                          sendEventTobackend(
                                            "PassengerAgeTouched",
                                            null,
                                            1,
                                          );
                                        }}
                                        sx={{
                                          "& .MuiInputLabel-root": {
                                            fontSize: "13px",
                                            "&.Mui-focused": {
                                              color: "#2D3FA8",
                                            },
                                          },

                                          "& .MuiOutlinedInput-root": {
                                            maxHeight: "40px",
                                            maxWidth: "110px",

                                            "& .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "#B7B7B7",
                                                borderWidth: "1px",
                                              },

                                            "&:hover .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "",
                                              },

                                            "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                              {
                                                borderColor: "#B7B7B7",
                                                borderWidth: "1px",
                                              },
                                          },

                                          "& label.Mui-focused": {
                                            color: "#1F1F1F",
                                          },
                                        }}
                                      />
                                    )}
                                  />
                                </div>

                                <div className="gender-switch-container">
                                  <span
                                    onClick={() =>
                                      handleMaleIconClick(item.SeatNumber)
                                    }
                                  >
                                    {item.gender ? (
                                      <img
                                        src="/images/MaleTransparent_1.png"
                                        style={{
                                          width: "40px",
                                          height: "40px",
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src="/images/MaleTransparent_1.png"
                                        style={{
                                          width: "40px",
                                          height: "40px",
                                        }}
                                      />
                                    )}
                                  </span>

                                  <FormControlLabel
                                    sx={{
                                      margin: 0,
                                      "& .MuiFormControlLabel-label": {
                                        fontSize: "14px",
                                        color: "#3D18B5",
                                        fontWeight: 600,
                                        marginLeft: "8px", // adjust spacing from switch
                                      },
                                    }}
                                    control={
                                      <Switch
                                        checked={item.gender}
                                        onChange={() =>
                                          handleGenderChange(item.SeatNumber)
                                        }
                                        sx={{
                                          "& .MuiSwitch-thumb": {
                                            backgroundColor: item.gender
                                              ? "#ff1493"
                                              : "#2D3FA8",
                                            boxShadow: item.gender
                                              ? "0 0 4px 2px rgba(0, 137, 123, 0.5)"
                                              : "none",
                                          },
                                          "& .MuiSwitch-track": {
                                            backgroundColor: item.gender
                                              ? "#F4CC13"
                                              : "#F4CC13",
                                            opacity: 0.4,
                                          },
                                        }}
                                      />
                                    }
                                  />

                                  <span
                                    onClick={() =>
                                      handleFeMaleIconClick(item.SeatNumber)
                                    }
                                  >
                                    {item.gender ? (
                                      <img
                                        src="/images/femaleTransparent1.png"
                                        style={{
                                          width: "45px",
                                          height: "45px",
                                        }}
                                      />
                                    ) : (
                                      <img
                                        src="/images/femaleTransparent1.png"
                                        style={{
                                          width: "45px",
                                          height: "45px",
                                        }}
                                      />
                                    )}
                                  </span>
                                </div>

                                <div className="seat-price">
                                  &#8377; {item.FARE}
                                </div>
                              </div>

                              {/* <div>
                                        <ThemeProvider theme={customTheme}>
                                  <TextField
                                    label="Age *"
                                    variant="outlined"
                                    size="small"
                                    fullWidth
                                    sx={{
                                      "& .MuiInputLabel-root": {
                                        fontSize: "13px",
                                        "&.Mui-focused": {
                                          color: "theme.secondary",
                                        },
                                      },

                                      "& .MuiOutlinedInput-root": {
                                        maxHeight: "38px",

                                        "& .MuiOutlinedInput-notchedOutline": {
                                          borderColor: "theme.secondary",
                                          borderWidth: "1px",
                                        },

                                        "&:hover .MuiOutlinedInput-notchedOutline":
                                          {
                                            borderColor: "",
                                          },

                                        "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                          {
                                            borderColor: "theme.secondary",
                                            borderWidth: "1px",
                                          },
                                      },

                                      "& label.Mui-focused": {
                                        color: "primary.main",
                                      },
                                    }}
                                  />
                                        </ThemeProvider>
                                     </div> */}

                              {/* <div className="gender-small">
                              <div className="gender-switch-container">
                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    color: "#3D18B5",
                                  }}
                                >
                                  {item.gender ? (
                                    <img
                                      src="/images/MaleTransparent_1.png"
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "4px",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src="/images/MaleTransparent_1.png"
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "4px",
                                      }}
                                    />
                                  )}{" "}
                                </span>

                                <FormControlLabel
                                  sx={{
                                    margin: 0,
                                    "& .MuiFormControlLabel-label": {
                                      fontSize: "14px",
                                      color: "#3D18B5",
                                      fontWeight: 600,
                                      marginLeft: "8px", // adjust spacing from switch
                                    },
                                  }}
                                  control={
                                    <Switch
                                      checked={item.gender}
                                      onChange={() =>
                                        handleGenderChange(item.SeatNumber)
                                      }
                                      sx={{
                                        "& .MuiSwitch-thumb": {
                                          backgroundColor: item.gender
                                            ? "#ff1493"
                                            : "#2D3FA8",
                                          boxShadow: item.gender
                                            ? "0 0 4px 2px rgba(0, 137, 123, 0.5)"
                                            : "none",
                                        },
                                        "& .MuiSwitch-track": {
                                          backgroundColor: item.gender
                                            ? "#F4CC13"
                                            : "#F4CC13",
                                          opacity: 0.4,
                                        },
                                      }}
                                    />
                                  }
                                />

                                <span
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  {" "}
                                  &nbsp;
                                  {item.gender ? (
                                    <img
                                      src="/images/femaleTransparent1.png"
                                      style={{
                                        width: "45px",
                                        height: "45px",
                                        borderRadius: "4px",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src="/images/femaleTransparent1.png"
                                      style={{
                                        width: "45px",
                                        height: "45px",
                                        borderRadius: "4px",
                                      }}
                                    />
                                  )}{" "}
                                </span>
                              </div>
                              <div className="seat-price">
                                &#8377; {item.FARE}
                              </div>
                            </div> */}
                            </div>
                          </div>
                        ))}

                        <div className="passenger-card-container-small">
                          <div className="card-top-button-br-dr">
                            Boarding Point
                          </div>
                          <div className="passenger-card-small">
                            <div className="boarding-dropping-info">
                              <div>
                                <div className="points">
                                  <div className="left">
                                    <abbr title={selectedBoardingName.PointName}>
                                    <span className="pointname">
                                      {" "}
                                      {selectedBoardingName
                                        ? selectedBoardingName.PointName
                                        : ""}{" "}
                                    </span>
                                     </abbr>
                                  </div>
                                  <div className="right">
                                    <span className="pointname">
                                      {" "}
                                      {selectedBoardingName
                                        ? selectedBoardingName.DepartureTime
                                        : ""}{" "}
                                    </span>
                                  </div>
                                </div>

                                <div className="dr-details">
                                   <div className="right-content-br">
                                    <span>
                                      {selectedBoardingName?.AddressLine2
                                        .LandMark1 !== ""
                                        ? selectedBoardingName?.LandMark1
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedBoardingName?.LandMark2 !== ""
                                        ? selectedBoardingName?.LandMark2
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedBoardingName?.AddressLine1 !== ""
                                        ? selectedBoardingName?.AddressLine1
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedBoardingName?.AddressLine2 !== ""
                                        ? selectedBoardingName?.AddressLine2
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedBoardingName?.AddressLine3 !== ""
                                        ? selectedBoardingName?.AddressLine3
                                        : ""}
                                    </span>
                                  </div>

                                  <div className="left-content-br">
                                    <div className="content-bottom">

                                       <ContactPhone mobileNumber={selectedBoardingName?.ContactMobileNumber} />
                                      <div className="icons-container">
                                        <a className="location-button" onClick={(e)=>{e.stopPropagation(); handleLocationClick();}}  >
                                          <CiLocationOn />
                                        </a>

                                        {/* <span className="location-button">
                                          <TbView360Number />
                                        </span> */}
                                      </div>

                                      {/* {selectedBoardingName?.ContactMobileNumber !=
                                      "" ? (
                                        <div className="mobile-number">
                                          <a
                                            href={
                                              "tel:" +
                                              selectedBoardingName?.ContactMobileNumber
                                            }
                                          >
                                            <CiPhone />{" "}
                                            <>
                                              {
                                                selectedBoardingName?.ContactMobileNumber
                                              }{" "}
                                            </>{" "}
                                          </a>{" "}
                                          &nbsp;
                                        </div>
                                      ) : (
                                        ""
                                      )} */}
                                    </div>
                                  </div>

                                 
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="passenger-card-container-small">
                          <div className="card-top-button-br-dr">
                            Dropping Point
                          </div>
                          <div className="passenger-card-small">
                            <div className="boarding-dropping-info">
                              <div>
                                <div className="points">
                                  <div className="left">
                                    <span className="pointname">
                                      {" "}
                                      {selectedDroppingName
                                        ? selectedDroppingName.PointName
                                        : ""}{" "}
                                    </span>
                                  </div>
                                  <div className="right">
                                    <span className="pointname">
                                      {" "}
                                      {selectedDroppingName
                                        ? selectedDroppingName.ArrivalTime
                                        : ""}{" "}
                                    </span>
                                  </div>
                                </div>

                                <div className="dr-details">
                                   <div className="right-content-br">
                                    <span>
                                      {selectedDroppingName?.AddressLine2
                                        .LandMark1 !== ""
                                        ? selectedDroppingName?.LandMark1
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedDroppingName?.LandMark2 !== ""
                                        ? selectedDroppingName?.LandMark2
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedDroppingName?.AddressLine1 !== ""
                                        ? selectedDroppingName?.AddressLine1
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedDroppingName?.AddressLine2 !== ""
                                        ? selectedDroppingName?.AddressLine2
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedDroppingName?.AddressLine3 !== ""
                                        ? selectedDroppingName?.AddressLine3
                                        : ""}
                                    </span>
                                  </div>
                                  <div className="left-content-br">
                                    <div className="content-bottom">
                                      

                                      <ContactPhone mobileNumber={selectedDroppingName?.ContactMobileNumber} />
                                      <div className="icons-container">
                                        <a className="location-button" onClick={(e)=>{e.stopPropagation();handleLocationClick();}}  >
                                          <CiLocationOn />
                                        </a>

                                        {/* <span className="location-button">
                                          <TbView360Number />
                                        </span> */}
                                      </div>

                                      {/* {selectedDroppingName?.ContactMobileNumber !=
                                      "" ? (
                                        <div className="mobile-number">
                                          <a
                                            href={
                                              "tel:" +
                                              selectedDroppingName?.ContactMobileNumber
                                            }
                                          >
                                            <CiPhone />{" "}
                                            <>
                                              {
                                                selectedDroppingName?.ContactMobileNumber
                                              }{" "}
                                            </>{" "}
                                          </a>{" "}
                                          &nbsp;
                                        </div>
                                      ) : (
                                        ""
                                      )} */}
                                    </div>
                                  </div>

                                 
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="payment-details-new">
                        <h3 className="headings-main">Payment Details</h3>
                        <div className="divider"></div>

                        <div className="payment-row">
                          <div className="perticulars"> Sub Total</div>
                          <div className="perticulars-amount">
                            {" "}
                            &#8377; {subtotal.toFixed(2)}
                          </div>
                        </div>

                        <div
                          className="payment-row"
                          style={{
                            borderTop: "1px solid rgba(244, 203, 19, 0.22)",
                          }}
                        >
                          <div className="perticulars"> Discount </div>
                          <div className="perticulars-amount">
                            {" "}
                            - &#8377; {discount.toFixed(2)}
                          </div>
                        </div>

                        <div
                          className="payment-row"
                          style={{
                            borderTop: "1px solid rgba(244, 203, 19, 0.22)",
                          }}
                        >
                          <div className="perticulars">
                            {" "}
                            GST ( {gstInpercent} % ){" "}
                          </div>
                          <div className="perticulars-amount">
                            {" "}
                            &#8377; {totalGst.toFixed(2)}
                          </div>
                        </div>
                        <div className="divider"></div>
                        <div className="payment-grand-row">
                          <div className="perticulars"> Grand Total </div>
                          <div className="perticulars-amount">
                            {" "}
                            &#8377; {grandTotal.toFixed(2)}
                          </div>
                        </div>
                      </div>

                      <div style={{ marginTop: "10px" }}>
                        <label>
                          <input
                            id="termsAndConditions"
                            type="checkbox"
                            onClick={(e) => {
                              setIsTermsAndConditionsChecked(e.target.checked);
                            }}
                          />{" "}
                          &nbsp; &nbsp; By Clicking on Book Now, I accept Terms
                          & Conditions, Privacy Policy
                        </label>

                        <div style={{ height: "200px",paddingBottom: "150px" }}></div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="unselected" style={{ height: "80vh" }}>
                        <span>
                          {" "}
                          Please Select Seats,Boarding and Dropping Points
                        </span>
                        <button onClick={() => setTabValue(0)}>
                          {" "}
                          Tap here to Select Seats,Boarding & Dropping Points
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </CustomTabPanel>
            </div>
          </DialogContent>
          <DialogActions
            component="div" 
            sx={{
              borderTop: "2px solid #2D3FA8",
              background: "linear-gradient(135deg, #f8faff 0%, #edf2ff 100%)",
              p: 0, // Set padding to 0 here so the collapsed state is exactly 130px
              m: 0,
              width: "100%",

              // 2. Force CSS Grid directly on the MUI component class rule
              "&.MuiDialogActions-root": {
                gridTemplateRows: isInfoExpanded ? "1fr" : "130px",
                transition: "grid-template-rows 0.3s ease-in-out",
                maxHeight: isInfoExpanded ? "400px" : "130px",
                justifyItems: "stretch", // Stretches inner box horizontally
                alignItems: "stretch",   // Stretches inner box vertically
              }
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                gap: "5px",
                p: "10px", // Apply the padding inside the wrapper
                width: "100%",
                height: "100%",
                minHeight: 0, // Crucial for grid item overflow calculation
                overflowY: "auto", // Handles scrolling if content exceeds max-height
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "0px 0px",
                  margin: "0px 0px",
                  width: "100%",
                }}
              >
                {tabValue > 0 ? (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "8px",
                      fontSize: "18px",
                      width: "32px",
                      height: "32px",
                      backgroundColor: "#1f1f1f",
                      color: "#fff",
                      borderRadius: "50%",
                      border: "1px solid #2D3FA8",
                    }}
                    onClick={() => setTabValue(tabValue - 1)}
                  >
                    <MdArrowBack />
                  </span>
                ) : (
                  <span></span>
                )}

                {selectedSeats.length > 0 && (
                  <span
                    onClick={() => setIsInfoExpanded(!isInfoExpanded)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      padding: "8px",
                      fontSize: "18px",
                      width: "32px",
                      height: "32px",
                      backgroundColor: "#1f1f1f",
                      color: "#fff",
                      borderRadius: "50%",
                      border: "1px solid #2D3FA8",
                    }}
                  >
                    {isInfoExpanded ? <MdClose /> : <MdInfoOutline />}
                  </span>
                )}
              </div>

              {selectedSeats.length > 0 ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    gap: "8px",
                  }}
                >
                  {/* Standard Horizontal Row */}
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      width: "100%",
                      alignItems: "center",
                    }}
                  >
                    <div className="selected-seat-list">
                      <div className="seat-selected-chip-container">
                        {updatedSeats?.map((item, idx) => (
                          <div
                            key={idx}
                            className="selected-seat-chip"
                            style={
                              item.gender
                                ? { backgroundColor: "#FFC0CB" }
                                : {
                                    backgroundColor: "#F0C800",
                                    color: "#1f1f1f",
                                    border: "1px solid #2D3FA8",
                                  }
                            }
                          >
                            {item.SeatNumber}
                          </div>
                        ))}
                      </div>
                    </div>

                    <span
                      className="grandtotal-amount"
                      style={{
                        fontSize: "17px",
                        fontWeight: "800",
                        color: "#2D3FA8",
                        letterSpacing: "-0.5px",
                      }}
                    >
                      ₹ {grandTotal}
                    </span>
                  </div>

                  {/* EXPANDED INDIVIDUAL DETAILS SECTION */}
                  {isInfoExpanded && (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                        padding: "8px 4px",
                        borderTop: "1px dashed #2D3FA8",
                        marginTop: "4px",
                      }}
                    >
                      <div
                        style={{
                          fontSize: "12px",
                          fontWeight: "700",
                          color: "#666",
                        }}
                      >
                        Fare Breakdown:
                      </div>
                      <div
                          key={"headerKey"}
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                            fontSize: "14px",
                          }}
                        >
                          <span style={{ fontWeight: "600" }}>Seat</span>
                          <span style={{ fontWeight: "600", textAlign: "right" }}>Fare</span>
                          <span style={{ fontWeight: "600", textAlign: "right" }}>Disc(%)</span>
                          <span style={{ fontWeight: "600", textAlign: "right" }}>Discount</span>
                          <span style={{ fontWeight: "600", textAlign: "right" }}>Amount</span>
                        </div>
                      {updatedSeats?.map((item, idx) => (
                        <div
                          key={idx}
                          style={{
                             display: "grid",
                             gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                             fontSize: "14px",
                          }}
                        >
                          <span>{item.SeatNumber}</span>
                          {/* Fallback to generic price variable if individual property names differ */}
                          <span style={{textAlign: "right"}}>
                            ₹ {item.FARE || "N/A"}
                          </span>
                          <span style={{textAlign: "right"}}> {discountInPercent}% </span>
                          <span style={{textAlign: "right"}}>  ₹ {(item.FARE*discountInPercent/100)} </span>
                          <span style={{ fontWeight: "600", textAlign: "right" }}> ₹ { (item.FARE - (item.FARE*discountInPercent/100)).toFixed(2) } </span>
                        </div>
                      ))}
                     
                      <div
                        key={"discKey"}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                          fontSize: "14px",
                          borderTop: "1px dashed #2D3FA8",
                          
                        }}
                      >
                        <span> Total </span>
                        <span style={{ textAlign: "right" }}> ₹ {subtotal} </span>
                         <span style={{ textAlign: "right" }}> - </span>
                        {/* Fallback to generic price variable if individual property names differ */}
                        <span style={{ fontWeight: "600", textAlign: "right" }}>
                          ₹ {discount}
                        </span>
                       
                        <span style={{ textAlign: "right" }}>₹ {(subtotal - discount).toFixed(2)} </span>
                      </div>
                      <div
                        key={"gstKey"}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                          fontSize: "14px",
                        }}
                       >
                        <span> GST </span>
                        {/* Fallback to generic price variable if individual property names differ */}
                        
                        <span style={{ textAlign: "right" }}>{gstInpercent}%</span>

                        <span style={{ textAlign: "right" }}> - </span>
                        <span style={{ textAlign: "right" }}> - </span>
                        <span style={{ textAlign: "right" }}>
                          
                          ₹ {totalGst.toFixed(2)}
                        </span>
                      </div>


                      <div
                        key={"gstKey"}
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                          fontSize: "14px",
                        }}
                       >
                        <span> Grand Total </span>
                        {/* Fallback to generic price variable if individual property names differ */}
                        
                        <span style={{ textAlign: "right" }}> - </span>

                        <span style={{ textAlign: "right" }}> - </span>
                        <span style={{ textAlign: "right" }}> - </span>
                        <span style={{ fontWeight: "600", textAlign: "right" }}>
                          {" "}
                          ₹ {grandTotal.toFixed(2)}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <span> Please select seats </span>
              )}

              {tabValue === 0 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "0px 0px",
                    margin: "0px 0px",
                    width: "100%",
                  }}
                >
                  <button
                    className="continue-button"
                    style={{ width: "100%" }}
                    onClick={() => {
                      if (selectedSeats.length > 0) {
                        setIsInfoExpanded(false);
                        setTabValue(1);
                      } else alert("Please select seats to continue");
                    }}
                  >
                    {" "}
                    <span>Boarding/Dropping Points</span>
                    <span>
                      {/* <MdArrowForward /> */}
                    </span>{" "}
                  </button>
                </div>
              )}

              {tabValue === 1 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "0px 0px",
                    margin: "0px 0px",
                    width: "100%",
                  }}
                >
                  <button
                    className="continue-button"
                    style={{ width: "100%" }}
                    onClick={() => {
                      passengerSectionRef.current?.scrollTo({ top: 0, behavior: "smooth" }); 
                      if (
                        selectedBoarding != null &&
                        selectedDropping != null
                      ) {
                        setIsInfoExpanded(false); 
                        setTabValue(2);
                      } else
                        alert("Please select Borading/Droppings to continue");
                    }}
                  >
                    <span>Fill Passanger Details</span>
                    <span>
                      {/* <MdArrowForward /> */}
                    </span> 
                  </button>
                </div>
              )}

              {tabValue === 2 && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "0px 0px",
                    margin: "0px 0px",
                    width: "100%",
                  }}
                >
                  <button
                    className={`continue-button ${isLoading ? "loading" : ""}`}
                    style={{ width: "100%" }}
                    onClick={handleSubmit(onSubmit, onInvalid)}
                    disabled={isLoading}
                  >
                    <span class="button-spinner"></span>
                    <span>Book Now </span>
                    <span>
                      {/* <MdArrowForward /> */}
                    </span>
                  </button>
                </div>
              )}
            </Box>
          </DialogActions>
        </Dialog>
        <form
          ref={formref}
          action={"/" + paths.BookSeatsTempEndPoint}
          method="POST"
          style={{ display: "none" }}
        >
          <input value={JSON.stringify(frompayload)} name="form_payload" />
        </form>
      </Fragment>

      <ComponentLevelLoader isLoading={isLoading} />
    </>
  );
};

export default JourneyDailogSmallScreen;
